import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { BbitWebShopAlgoliaService } from '@bbitgmbh/webshop.sdk';
import { BbitWebsiteMetaDataService, I18nPipe } from '@bbitgmbh/website.sdk';
import { BehaviorSubject } from 'rxjs';
import { CategoryService } from '../../category/category.service';
import { ItemListItemComponent } from '../item-list/item-list-item/item-list-item.component';

@Component({
  selector: 'app-new-products',
  templateUrl: './new-products.component.html',
  styleUrl: './new-products.component.scss',
  imports: [ItemListItemComponent, AsyncPipe, I18nPipe],
})
export class NewProductsComponent {
  private _meta = inject(BbitWebsiteMetaDataService);
  category = inject(CategoryService);
  private _algolia = inject(BbitWebShopAlgoliaService);

  public hits = new BehaviorSubject<any[]>([]);

  async ngOnInit() {
    this._meta.update({
      title: { key: 'newProducts' },
      description: '',
      // keywords: [],
    });
    await this._algolia.clear();
    const algoliaResult = await this._algolia.search({
      query: '',
      filters: 'flags:#JyWSmSfX6cxZGQQRDJdfU',
      hitsPerPage: 128,
    });
    this.hits.next(algoliaResult.hits || []);
  }
}
